// extracted by mini-css-extract-plugin
export var paginationContainer = "_42-0";